import React from 'react';

export default function Settings() {
  return <h2>SETTINGS</h2>;
}